// Copied from kontentino-auth `src/utils/passwordPolicy.ts`; keep in sync with
// api `app/Rules/User/CognitoPasswordPolicy.php`. Whitespace is rejected, never trimmed.
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;

export const PASSWORD_UPPERCASE = /[A-Z]/;
export const PASSWORD_LOWERCASE = /[a-z]/;
export const PASSWORD_NUMBER = /[0-9]/;
// Cognito's special characters without the space.
export const PASSWORD_SYMBOLS = '^$*.[]{}()?"!@#%&/\\,><\':;|_~`=+-';
export const PASSWORD_SYMBOL = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/;

// eslint-disable-next-line no-control-regex
const OUTER_WHITESPACE = /^[ \t\n\x0B\f\r]|[ \t\n\x0B\f\r]$/;
const LINE_BREAK = /[\r\n]/;

export function hasForbiddenWhitespace(password: string): boolean {
  return OUTER_WHITESPACE.test(password) || LINE_BREAK.test(password);
}
